import { useMemo } from 'react'
import moment from 'moment-timezone'
import {
    SHIPPED_STATUS,
    UPS_CARRIER_TYPE,
    PARTIAL_SHIPPING_DISPLAY,
    SHIPPED_DISPLAY,
    ESTIMATED_SHIP_DATE_DISPLAY,
} from '@Orders/constants'
import {
    salesOrder_salesOrder_shipments_items,
    salesOrder_salesOrder_salesOrderLines_items,
} from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'
import { US_TIMEZONE } from '@Admin/JobBoardPage/constant'

const dateFormat = 'ddd, MMM DD'

export const getOrderStepsDateFormat = (
    date?: string,
    carrier?: string | null,
) => {
    if (date) {
        if (carrier === UPS_CARRIER_TYPE) {
            return moment.utc(date).tz(US_TIMEZONE).format(dateFormat)
        }
        return moment(date).tz(US_TIMEZONE).format(dateFormat)
    }
    return 'Not available'
}

export const useShippedString = (
    shipments: salesOrder_salesOrder_shipments_items[],
    salesOrderLines: salesOrder_salesOrder_salesOrderLines_items[],
) => {
    return useMemo(() => {
        let shippedString = ESTIMATED_SHIP_DATE_DISPLAY

        if (shipments.length > 0) {
            if (
                salesOrderLines &&
                salesOrderLines.some(
                    line => line.deliveryStatus !== SHIPPED_STATUS,
                )
            ) {
                shippedString = PARTIAL_SHIPPING_DISPLAY
            } else {
                shippedString = SHIPPED_DISPLAY
            }
        }
        return shippedString
    }, [salesOrderLines, shipments])
}
